/* Hello Couleur — Config & calcul des frais de port AU POIDS.
   Tarifs nets 2026 (France métropolitaine), relevés sur laposte.fr et mondialrelay.fr.
   Le poids de chaque produit vit dans products-index.js (champ "weight", en grammes ;
   les tirages portent "variant_weights" A5/A4/A3). Ce module ne fait que mapper
   poids du panier -> prix par transporteur.

   À METTRE À JOUR si les transporteurs changent leurs grilles (1 endroit unique). */
(function () {
  // Modes proposés, dans l'ordre d'affichage (du moins cher / plus lent au plus rapide).
  // transitMin/Max = jours ouvrés de transport (atelier → client) après expédition.
  var METHODS = [
    { key: 'timbre',        label: 'Timbre simple (Lettre verte)',        desc: 'Envoi économique, sans suivi · 3-5 j',         tracked: false, transitMin: 3, transitMax: 5 },
    { key: 'lettre_suivie', label: 'Lettre suivie',                       desc: 'Avec numéro de suivi · 3-5 j',                  tracked: true,  transitMin: 3, transitMax: 5 },
    { key: 'mr_relais',     label: 'Point relais Mondial Relay',            desc: 'Retrait en point relais · 3-5 j · offert dès 50 €', tracked: true,  transitMin: 3, transitMax: 5 },
    { key: 'mr_domicile',   label: 'Mondial Relay — Domicile',            desc: 'Livraison à domicile · 3-5 j',                  tracked: true,  transitMin: 3, transitMax: 5 },
    { key: 'colissimo',     label: 'Colissimo — Domicile',                desc: 'Avec suivi · 3-5 j',                            tracked: true,  transitMin: 3, transitMax: 5 }
  ];

  // Préparation de la commande (atelier Hello Couleur) — en jours ouvrés.
  var PROCESSING_MIN_DAYS = 1;
  var PROCESSING_MAX_DAYS = 2;
  // Cut-off horaire : commande passée avant cette heure (FR) → traitement démarré le jour même.
  var CUTOFF_HOUR = 13;
  // Plafond calendaire de la borne haute affichée : on n'annonce JAMAIS une réception
  // au-delà de N jours calendaires après la commande (anti-affichage déceptif, ex. « 11 j »).
  var MAX_DELIVERY_DAYS = 8;

  // Grilles : [poidsMaxEnGrammes, prixEUR]. On prend le 1er palier dont le poids <= max.
  var RATES = {
    // 2026-10-06 (Olivier) : Timbre + Lettre suivie PLAFONNÉS à 100 g ENVELOPPE BULLE COMPRISE, soit 80 g d'articles
    // (au-delà, methodPrice renvoie null → mode non proposé) : alignement strict sur la caisse Shopify (lettres 0-100 g).
    timbre:        [[20, 1.52], [100, 3.10]],
    lettre_suivie: [[20, 2.02], [100, 3.60]],
    // 2026-10-06 : point relais Mondial Relay = tarif AU POIDS sous 50 € (Olivier : pas de prix unique), offert dès 50 €.
    mr_relais:     [[500, 4.15], [1000, 5.99], [3000, 7.99], [4000, 9.99], [10000, 15.99], [25000, 25.99]], // grille MR au 15/06/2026 (MAJ 12/10)
    mr_domicile:   [[250, 4.99], [500, 7.49], [1000, 9.49], [2000, 10.99], [4000, 16.39], [5000, 16.39], [10000, 24.99], [15000, 31.49], [25000, 42.99]],
    colissimo:     [[250, 5.49], [500, 7.59], [750, 9.29], [1000, 9.59], [2000, 11.19], [5000, 17.39], [10000, 25.29], [15000, 31.99], [30000, 39.59]]
  };

  // 2026-10-06 : tarifs à l'étranger (profil Shopify : zones « Belgique + Luxembourg » et « Suisse »), emballage compris.
  // Pas de livraison offerte hors France. Pays non livré : cheapest() renvoie null (« calculée au paiement »).
  // Lettres plafonnées à 100 g enveloppe comprise, comme en France (2026-10-06).
  var INTL_LETTRE = [[20, 2.25], [100, 4.85]];
  var INTL_SUIVIE = [[20, 5.05], [100, 7.65]];
  var BE_LU = {
    methods: [
      { key: 'lettre', label: 'Envoi économique (lettre)' },
      { key: 'lettre_suivie', label: 'Courrier suivi' },
      { key: 'mr_domicile', label: 'Mondial Relay — Domicile' }
    ],
    rates: {
      lettre: INTL_LETTRE, lettre_suivie: INTL_SUIVIE,
      mr_domicile: [[500, 12.50], [1000, 13.80], [2000, 14.90], [4000, 18.20], [5000, 18.50], [10000, 28.50], [15000, 35.00], [25000, 47.90]]
    }
  };
  var RATES_PAYS = {
    BE: BE_LU,
    LU: BE_LU,
    CH: {
      methods: [
        { key: 'lettre', label: 'Envoi économique (lettre)' },
        { key: 'lettre_suivie', label: 'Courrier suivi' },
        { key: 'colissimo_int', label: 'Colissimo International' }
      ],
      rates: {
        lettre: INTL_LETTRE, lettre_suivie: INTL_SUIVIE,
        colissimo_int: [[500, 14.99], [1000, 19.39], [2000, 22.19], [5000, 28.59], [10000, 46.99], [15000, 67.99], [30000, 87.99]]
      }
    }
  };

  var FREE_THRESHOLD = 50;       // € — 2026-10-06 : livraison offerte dès 50 € en point relais Mondial Relay UNIQUEMENT (particuliers, France métro) ; autres modes payants
  var FREE_METHOD = 'mr_relais'; // seul mode offert au-delà du seuil ; pas de plafond (les comptes pro n'ont pas accès aux points relais)
  var TIRAGE_VARIANT_WEIGHTS = { A5: 43, A4: 85, A3: 150 };
  var DEFAULT_WEIGHT = 15;       // fallback si poids inconnu

  // 2026-10-06 : la caisse Shopify ajoute à chaque commande le poids de l'emballage par défaut
  // (enveloppe bulle, 20 g ; tarifs « Poids du colis »). Le calcul du panier l'ajoute donc aussi.
  var PACKAGE_WEIGHT = 20;

  // Prix d'un mode pour un poids d'articles donné (g), emballage compris. null si indisponible (hors grille).
  function methodPrice(key, grams, pays) {
    var table = (pays && pays !== 'FR' && RATES_PAYS[pays]) ? RATES_PAYS[pays].rates[key] : RATES[key];
    if (!table) return null;
    var g = (grams || 0) + PACKAGE_WEIGHT;
    for (var i = 0; i < table.length; i++) {
      if (g <= table[i][0]) return table[i][1];
    }
    return null;
  }

  // Liste de tous les modes avec leur prix pour ce poids (price null = indisponible).
  function methodsForWeight(grams) {
    return METHODS.map(function (m) {
      return { key: m.key, label: m.label, desc: m.desc, tracked: m.tracked, price: methodPrice(m.key, grams) };
    });
  }

  // Mode le moins cher disponible pour ce poids (pays : 'FR' par défaut ; BE, LU, CH = tarifs du pays).
  function cheapest(grams, pays) {
    var best = null;
    if (pays && pays !== 'FR' && !RATES_PAYS[pays]) return null; // pays non livré
    var liste = (pays && pays !== 'FR') ? RATES_PAYS[pays].methods : METHODS;
    liste.forEach(function (m) {
      var p = methodPrice(m.key, grams, pays);
      if (p === null) return;
      if (best === null || p < best.price) best = { key: m.key, label: m.label, price: p };
    });
    return best; // {key,label,price} ou null
  }

  // Poids (g) d'une ligne de panier à partir de l'objet produit (index) + libellé de variante.
  function lineWeight(product, variantLabel) {
    if (!product) return DEFAULT_WEIGHT;
    if (product.type === 'tirage' && variantLabel) {
      for (var k in TIRAGE_VARIANT_WEIGHTS) {
        if (variantLabel.indexOf(k) !== -1) return TIRAGE_VARIANT_WEIGHTS[k];
      }
    }
    return (typeof product.weight === 'number' && product.weight > 0) ? product.weight : DEFAULT_WEIGHT;
  }

  function fmt(n) { return n.toFixed(2).replace('.', ',') + ' €'; }

  // -- Estimation de date de livraison ---------------------------------------
  // Skip samedi (6) et dimanche (0). Jours fériés FR non gérés (simplifie ; cas marginal).
  function isWeekend(d) { var w = d.getDay(); return w === 0 || w === 6; }
  function addBusinessDays(date, n) {
    var d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (!isWeekend(d)) added++;
    }
    return d;
  }
  // Si la commande est passée APRÈS le cut-off ou un week-end, on démarre le
  // traitement le prochain jour ouvré.
  function nextProcessingStart(now) {
    var d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (now.getHours() >= CUTOFF_HOUR || isWeekend(now)) {
      do { d.setDate(d.getDate() + 1); } while (isWeekend(d));
    }
    return d;
  }
  // Retourne {from: Date, to: Date} = fourchette d'arrivée chez le client.
  function estimateDelivery(modeKey, now) {
    now = now || new Date();
    var method = null;
    for (var i = 0; i < METHODS.length; i++) if (METHODS[i].key === modeKey) { method = METHODS[i]; break; }
    if (!method) return null;
    var processStart = nextProcessingStart(now);
    var shipMin = addBusinessDays(processStart, PROCESSING_MIN_DAYS - 1); // jour d'expé optimiste
    var shipMax = addBusinessDays(processStart, PROCESSING_MAX_DAYS - 1);
    var from = addBusinessDays(shipMin, method.transitMin);
    var to = addBusinessDays(shipMax, method.transitMax);
    // Plafonne la borne haute à MAX_DELIVERY_DAYS jours calendaires après la commande.
    var cap = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    cap.setDate(cap.getDate() + MAX_DELIVERY_DAYS);
    if (cap.getDay() === 0) cap.setDate(cap.getDate() - 1); // dimanche → samedi (pas de livraison le dimanche)
    if (to > cap) to = cap;
    if (to < from) to = from; // garde-fou : la borne haute ne passe jamais sous la borne basse
    return { from: from, to: to };
  }

  var WEEKDAYS = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
  var MONTHS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  function fmtDay(d) { return WEEKDAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()]; }
  // « entre le mar. 3 juin et le ven. 6 juin » ou « le mar. 3 juin » si même jour.
  function formatDeliveryWindow(window) {
    if (!window) return '';
    var f = window.from, t = window.to;
    if (f.getTime() === t.getTime()) return 'le ' + fmtDay(f);
    return 'entre le ' + fmtDay(f) + ' et le ' + fmtDay(t);
  }

  window.HC_SHIPPING = {
    METHODS: METHODS, RATES: RATES, FREE_THRESHOLD: FREE_THRESHOLD, FREE_METHOD: FREE_METHOD, PACKAGE_WEIGHT: PACKAGE_WEIGHT, RATES_PAYS: RATES_PAYS,
    methodPrice: methodPrice, methodsForWeight: methodsForWeight,
    cheapest: cheapest, lineWeight: lineWeight, fmt: fmt,
    estimateDelivery: estimateDelivery, formatDeliveryWindow: formatDeliveryWindow,
    PROCESSING_MIN_DAYS: PROCESSING_MIN_DAYS, PROCESSING_MAX_DAYS: PROCESSING_MAX_DAYS,
    CUTOFF_HOUR: CUTOFF_HOUR
  };
})();
